export enum IconTestIds {
  Arrow = 'arrow-icon',
  Checkmark = 'checkmark-icon',
  FeatureCheckmark = 'feature-checkmark-icon',
  Grow = 'grow-icon',
  More = 'more-icon',
  Play = 'play-icon',
  Plus = 'plus-icon',
}
